module.exports = __webpack_public_path__ + "img/ic-trash.bf6457f3.svg";